import React from 'react';
import Icon from '../../Components/Icons/Icon';
import Modal, { useModal } from '../../Components/Modal';
import Grid from '../../Components/Formatting/Grid';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';
import { usePreference } from '../../Data/Preference';
import DateSquare from '../Home/Widgets/ScheduleOverview/DateSquare';
import { dateToString } from '../../Services/helpers';

const FirstLook = () => {
    const [isOpen, setIsOpen] = usePreference('calendar:firstLook', true);

    return <>
        <Modal isOpen={isOpen}
            setIsOpen={() => setIsOpen(false)}
            title="Introducing the new calendar"
            dismissible
        >
            <Inner />
        </Modal>
    </>
}

const Inner = () => {
    const {closeModal} = useModal();

    const date = dateToString(new Date());

    return <>
        <Grid
            gapY="gap-y-6"
            className="my-6 text-muted text-sm items-center text-balance"
            items={[
                [
                    <span className="text-2xl">💅</span>,
                    <>
                        <strong className="text-slate-900">Improved look &amp; feel</strong><br />
                        Easier to read and use, with a refreshed design.
                    </>
                ],
                [
                    <DateSquare date={date} today={date} ring />,
                    <>
                        <strong className="text-slate-900">Suggested jobs</strong><br />
                        Jobs are intelligently suggested right in the calendar.
                    </>
                ],
                [
                    <span className="text-2xl">👆</span>,
                    <>
                        <strong className="text-slate-900">Easily move jobs</strong><br />
                        Simply drag and drop a job to move it to a different day or person.
                    </>
                ],
                [
                    <span className="text-2xl">🤑</span>,
                    <>
                        <strong className="text-slate-900">Daily totals</strong><br />
                        See the daily totals change as you move jobs.
                    </>
                ],
                [
                    <Icon icon="ArrowsDiagonalOut" size="2x" className="fill-muted" />,
                    <>
                        <strong className="text-slate-900">Use all your screen</strong><br />
                        Make full use of the screen if you're on a desktop.
                    </>
                ],
                [
                    <span className="text-2xl">🪛</span>,
                    <>
                        <strong className="text-slate-900">Still improving</strong><br />
                        We wanted to let you try this early, so things might change.
                    </>
                ],
                [
                    <span className="text-2xl">💬</span>,
                    <>
                        <strong className="text-slate-900">Share your thoughts</strong><br />
                        Your feedback guides us, so let us know what you think!
                    </>
                ],
                [
                    <span className="text-2xl">🎁</span>,
                    <>
                        <strong className="text-slate-900">Previous version</strong><br />
                        You can still use the previous version if you prefer, use the toggle at the top left.
                    </>
                ]
            ]}
        />

        <ButtonRow arrange="center">
            <Button theme="primary" onClick={closeModal} label="Got it!" />
        </ButtonRow>
    </>
}

export default FirstLook;
